import { Compass, Library, MessageSquare, Target } from 'lucide-react';

/**
 * The four primary destinations of the Etch frame (spec §8.1/§8.2).
 *
 * Route knowledge lives here exactly once — `App.jsx` mounts the routes,
 * the sidebar, the bottom navigation and the document title all read this
 * table, so a renamed route can never leave a stale nav entry behind.
 */
export const DESTINATIONS = [
  {
    id: 'chat',
    to: '/chat',
    labelKey: 'nav.chat',
    Icon: MessageSquare,
    // `/` is the start page and renders Chat — both paths are "Chat".
    isActive: (pathname) => pathname === '/' || pathname.startsWith('/chat'),
  },
  {
    id: 'missions',
    to: '/missions',
    labelKey: 'nav.missions',
    Icon: Target,
    badge: 'due',
    isActive: (pathname) => pathname.startsWith('/missions'),
  },
  {
    id: 'onboarding',
    to: '/onboarding',
    labelKey: 'nav.onboarding',
    Icon: Compass,
    isActive: (pathname) => pathname.startsWith('/onboarding'),
  },
  {
    id: 'knowledge',
    to: '/knowledge',
    labelKey: 'nav.knowledge',
    Icon: Library,
    isActive: (pathname) => pathname.startsWith('/knowledge'),
  },
];

/** Destinations shown in the mobile bottom bar — "Wissen" moves into "Mehr". */
export const MOBILE_DESTINATIONS = DESTINATIONS.filter((d) => d.id !== 'knowledge');

/**
 * Route → document-title key (spec §8: "<Seite> · Etch").
 * Ordered: the first matching entry wins, so `/settings` never falls through
 * to the `/` chat entry.
 */
const TITLE_ROUTES = [
  { test: (p) => p.startsWith('/admin'), key: 'nav.admin' },
  { test: (p) => p.startsWith('/settings'), key: 'nav.settings' },
  ...DESTINATIONS.map((d) => ({ test: d.isActive, key: d.labelKey })),
];

/** Returns the i18n key for the current route, or null for unknown paths. */
export function titleKeyForPath(pathname) {
  return TITLE_ROUTES.find((entry) => entry.test(pathname))?.key ?? null;
}
